var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41644 9.54743H4.37731C3.48013 9.54743 2.75 10.2776 2.75 11.1747V19.4247C2.75 19.6117 2.82563 19.7953 2.95831 19.9266C3.09031 20.0586 3.27387 20.1349 3.46088 20.1349H18.1273C18.3136 20.1349 18.4965 20.0593 18.6285 19.9266C18.7605 19.7953 18.8368 19.6117 18.8368 19.4247V3.84118C18.8368 2.94399 18.1074 2.21387 17.2102 2.21387H8.04375C7.14656 2.21387 6.41644 2.94399 6.41644 3.84118V9.54743ZM7.8375 3.63493H17.4171V18.7139H11.5039V11.1747C11.5039 10.2776 10.7738 9.54743 9.87663 9.54743H7.8375V3.63493ZM10.0836 10.9685V18.7139H4.17106V10.9685H10.0836Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0834 5.65137H11.9167V7.4847H10.0834V5.65137ZM13.7501 5.65137H15.5834V7.4847H13.7501V5.65137ZM13.7501 9.34645H15.5834V11.1514H13.7501V9.34645ZM13.7501 12.9847H15.5834V14.818H13.7501V12.9847ZM6.41675 12.9856H8.25008V14.8189H6.41675V12.9856Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBuildings);
export default __webpack_public_path__ + "static/media/icons-buildings.8ef6bc69fea1038506e64c26a76e006f.svg";
export { ForwardRef as ReactComponent };